// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* The Genius reader (GeniusReader.js): the shared sheet (.apr-dialog), wider
   on a desktop for reading, the text scrolling inside it so the title and the
   two buttons stay in view. Rob's written words in Newsreader; the frame in
   Inter. The cited part is marked with a 2 px rule and the raised surface,
   never a colour (there is no hue accent). */

.apr-dialog.genius-reader {
  display: flex;
  flex-direction: column;
  max-width: 640px;
  max-height: min(88vh, 860px);
  max-height: min(88dvh, 860px);
  padding-bottom: 20px;
}

.genius-head {
  flex: none;
  padding-right: 44px; /* clear of the close button */
  margin-bottom: 12px;
}

.genius-book {
  margin: 0;
  font-family: var(--font-serif);
  font-weight: 440;
  font-size: 1.375rem;
  line-height: 1.2;
  letter-spacing: 0;
  font-variation-settings: "opsz" 24;
  color: var(--brand-fg);
  text-wrap: balance;
}

.genius-chapter {
  margin: 6px 0 0;
  font-size: 0.9375rem;
  line-height: 1.4;
  font-weight: 600;
  color: var(--brand-fg);
}

.genius-by {
  margin: 2px 0 0;
  font-size: 0.8125rem;
  line-height: 1.4;
  color: var(--brand-muted);
}

.genius-status {
  margin: 8px 0 4px;
  font-size: 0.9375rem;
  line-height: 1.5;
  color: var(--brand-fg-read);
}

.genius-status .apr-btn--text { margin-top: 4px; }

.genius-text {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  margin: 0 -24px;
  padding: 4px 24px 8px;
  border-top: 1px solid var(--brand-line);
  border-bottom: 1px solid var(--brand-line);
}

.genius-text:focus-visible {
  outline: 2px solid var(--brand-focus);
  outline-offset: -2px;
}

.genius-p {
  margin: 14px 0;
  font-family: var(--font-serif);
  font-weight: 400;
  font-size: var(--fs-quote);
  line-height: 1.55;
  font-variation-settings: "opsz" 18;
  color: var(--brand-fg-read);
  overflow-wrap: break-word;
}

.genius-h {
  margin: 22px 0 6px;
  font-family: var(--font-serif);
  font-weight: 600;
  font-size: 1.0625rem;
  line-height: 1.3;
  font-variation-settings: "opsz" 18;
  color: var(--brand-fg);
}

.genius-p.is-cited {
  margin-left: -14px;
  padding: 10px 12px 10px 12px;
  border-left: 2px solid var(--brand-fg);
  border-radius: 0 var(--radius-sm) var(--radius-sm) 0;
  background: var(--brand-surface-2);
}

.genius-mark {
  background: none;
  color: var(--brand-fg);
}

/* The words AI Rob quoted, word for word: a 2 px rule under them, inside the
   marked paragraph; the words around them keep the reading colour. */
.genius-mark.is-quote {
  text-decoration-line: underline;
  text-decoration-thickness: 2px;
  text-underline-offset: 0.22em;
  text-decoration-color: var(--brand-fg);
  text-decoration-skip-ink: auto;
}

.genius-note {
  flex: none;
  margin: 10px 0 0;
  font-size: 0.8125rem;
  line-height: 1.4;
  color: var(--brand-muted);
}

.genius-actions {
  flex: none;
  margin-top: 16px;
}

.genius-actions .apr-btn { min-height: 48px; }

@media (max-width: 600px) {
  .apr-dialog.genius-reader {
    max-height: 92vh;
    max-height: 92dvh;
    padding-bottom: calc(16px + env(safe-area-inset-bottom, 0px));
  }

  .genius-text {
    margin: 0 -20px;
    padding: 4px 20px 8px;
  }

  .genius-book { font-size: 1.25rem; }

  .genius-p.is-cited { margin-left: -10px; padding-left: 8px; }

  .genius-actions { margin-top: 12px; gap: 8px; }
}

/* Answers that cite the book: the number is a button that opens the reader.
   It looks and hits like the other numbers (ChatView.css). */
.cv-markdown .cv-cite .cv-cite-book {
  appearance: none;
  font: inherit;
  padding: 0.25em 0.2em;
  margin: 0 -0.2em;
  border: 0;
  border-radius: 4px;
  background: none;
  color: var(--brand-fg);
  line-height: 0;
  text-decoration-line: underline;
  text-decoration-thickness: 1px;
  text-underline-offset: 2px;
  cursor: pointer;
}

.cv-markdown .cv-cite .cv-cite-book:hover { background: var(--brand-surface-2); }

@media (hover: none) {
  .cv-markdown .cv-cite .cv-cite-book { position: relative; }
  .cv-markdown .cv-cite .cv-cite-book::after { content: ''; position: absolute; inset: -12px -9px; }
  .cv-markdown .cv-cite-more .cv-cite-book::after { left: 0; }
  .cv-markdown .cv-cite:has(+ .cv-cite-more) .cv-cite-book::after { right: 0; }
}

@media (hover: hover) {
  .cv-markdown .cv-cite .cv-cite-book {
    display: inline-block;
    min-width: 1.2em;
    padding: 0.5em 0.3em;
    margin: -0.5em -0.3em;
    line-height: 1;
    text-align: center;
  }
}

/* A chapter's source row: a button, laid out like the linked rows. */
button.cv-src {
  appearance: none;
  width: 100%;
  margin: 0;
  border: 0;
  border-bottom: 1px solid var(--brand-line);
  background: none;
  font: inherit;
  text-align: left;
  cursor: pointer;
}

button.cv-src:hover .cv-src-title { text-decoration: underline; text-underline-offset: 0.2em; }
button.cv-src:hover .cv-src-go { background: var(--brand-surface-2); }

/* Under an answer: one quiet line for the book, one for The Net's channel. */
.cv-promo {
  margin: 8px 0 0;
  max-width: var(--measure);
  font-size: 0.8125rem;
  line-height: 1.4;
  color: var(--brand-muted);
}

.cv-promo a {
  display: inline-flex;
  align-items: center;
  min-height: 44px;
  color: var(--brand-fg);
  text-decoration-line: underline;
  text-underline-offset: 0.2em;
}

.cv-promo + .cv-promo { margin-top: -8px; }
`, "",{"version":3,"sources":["webpack://./src/components/GeniusReader.css"],"names":[],"mappings":"AAAA;;;;6CAI6C;;AAE7C;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,mBAAmB,EAAE,8BAA8B;EACnD,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,kCAAkC;EAClC,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA,gCAAgC,eAAe,EAAE;;AAEjD;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,qBAAqB;EACrB,uCAAuC;EACvC,0CAA0C;AAC5C;;AAEA;EACE,qCAAqC;EACrC,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,8BAA8B;EAC9B,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;EACjB,kCAAkC;EAClC,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,sCAAsC;EACtC,oDAAoD;EACpD,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;qEACqE;AACrE;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,6BAA6B;EAC7B,sCAAsC;EACtC,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA,2BAA2B,gBAAgB,EAAE;;AAE7C;EACE;IACE,gBAAgB;IAChB,iBAAiB;IACjB,6DAA6D;EAC/D;;EAEA;IACE,eAAe;IACf,qBAAqB;EACvB;;EAEA,eAAe,kBAAkB,EAAE;;EAEnC,qBAAqB,kBAAkB,EAAE,iBAAiB,EAAE;;EAE5D,kBAAkB,gBAAgB,EAAE,QAAQ,EAAE;AAChD;;AAEA;6DAC6D;AAC7D;EACE,gBAAgB;EAChB,aAAa;EACb,qBAAqB;EACrB,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,+BAA+B;EAC/B,8BAA8B;EAC9B,0BAA0B;EAC1B,eAAe;AACjB;;AAEA,4CAA4C,kCAAkC,EAAE;;AAEhF;EACE,sCAAsC,kBAAkB,EAAE;EAC1D,6CAA6C,WAAW,EAAE,kBAAkB,EAAE,iBAAiB,EAAE;EACjG,kDAAkD,OAAO,EAAE;EAC3D,kEAAkE,QAAQ,EAAE;AAC9E;;AAEA;EACE;IACE,qBAAqB;IACrB,gBAAgB;IAChB,oBAAoB;IACpB,qBAAqB;IACrB,cAAc;IACd,kBAAkB;EACpB;AACF;;AAEA,qEAAqE;AACrE;EACE,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,SAAS;EACT,0CAA0C;EAC1C,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA,oCAAoC,0BAA0B,EAAE,4BAA4B,EAAE;AAC9F,iCAAiC,kCAAkC,EAAE;;AAErE,6EAA6E;AAC7E;EACE,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA,wBAAwB,gBAAgB,EAAE","sourcesContent":["/* The Genius reader (GeniusReader.js): the shared sheet (.apr-dialog), wider\n   on a desktop for reading, the text scrolling inside it so the title and the\n   two buttons stay in view. Rob's written words in Newsreader; the frame in\n   Inter. The cited part is marked with a 2 px rule and the raised surface,\n   never a colour (there is no hue accent). */\n\n.apr-dialog.genius-reader {\n  display: flex;\n  flex-direction: column;\n  max-width: 640px;\n  max-height: min(88vh, 860px);\n  max-height: min(88dvh, 860px);\n  padding-bottom: 20px;\n}\n\n.genius-head {\n  flex: none;\n  padding-right: 44px; /* clear of the close button */\n  margin-bottom: 12px;\n}\n\n.genius-book {\n  margin: 0;\n  font-family: var(--font-serif);\n  font-weight: 440;\n  font-size: 1.375rem;\n  line-height: 1.2;\n  letter-spacing: 0;\n  font-variation-settings: \"opsz\" 24;\n  color: var(--brand-fg);\n  text-wrap: balance;\n}\n\n.genius-chapter {\n  margin: 6px 0 0;\n  font-size: 0.9375rem;\n  line-height: 1.4;\n  font-weight: 600;\n  color: var(--brand-fg);\n}\n\n.genius-by {\n  margin: 2px 0 0;\n  font-size: 0.8125rem;\n  line-height: 1.4;\n  color: var(--brand-muted);\n}\n\n.genius-status {\n  margin: 8px 0 4px;\n  font-size: 0.9375rem;\n  line-height: 1.5;\n  color: var(--brand-fg-read);\n}\n\n.genius-status .apr-btn--text { margin-top: 4px; }\n\n.genius-text {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  margin: 0 -24px;\n  padding: 4px 24px 8px;\n  border-top: 1px solid var(--brand-line);\n  border-bottom: 1px solid var(--brand-line);\n}\n\n.genius-text:focus-visible {\n  outline: 2px solid var(--brand-focus);\n  outline-offset: -2px;\n}\n\n.genius-p {\n  margin: 14px 0;\n  font-family: var(--font-serif);\n  font-weight: 400;\n  font-size: var(--fs-quote);\n  line-height: 1.55;\n  font-variation-settings: \"opsz\" 18;\n  color: var(--brand-fg-read);\n  overflow-wrap: break-word;\n}\n\n.genius-h {\n  margin: 22px 0 6px;\n  font-family: var(--font-serif);\n  font-weight: 600;\n  font-size: 1.0625rem;\n  line-height: 1.3;\n  font-variation-settings: \"opsz\" 18;\n  color: var(--brand-fg);\n}\n\n.genius-p.is-cited {\n  margin-left: -14px;\n  padding: 10px 12px 10px 12px;\n  border-left: 2px solid var(--brand-fg);\n  border-radius: 0 var(--radius-sm) var(--radius-sm) 0;\n  background: var(--brand-surface-2);\n}\n\n.genius-mark {\n  background: none;\n  color: var(--brand-fg);\n}\n\n/* The words AI Rob quoted, word for word: a 2 px rule under them, inside the\n   marked paragraph; the words around them keep the reading colour. */\n.genius-mark.is-quote {\n  text-decoration-line: underline;\n  text-decoration-thickness: 2px;\n  text-underline-offset: 0.22em;\n  text-decoration-color: var(--brand-fg);\n  text-decoration-skip-ink: auto;\n}\n\n.genius-note {\n  flex: none;\n  margin: 10px 0 0;\n  font-size: 0.8125rem;\n  line-height: 1.4;\n  color: var(--brand-muted);\n}\n\n.genius-actions {\n  flex: none;\n  margin-top: 16px;\n}\n\n.genius-actions .apr-btn { min-height: 48px; }\n\n@media (max-width: 600px) {\n  .apr-dialog.genius-reader {\n    max-height: 92vh;\n    max-height: 92dvh;\n    padding-bottom: calc(16px + env(safe-area-inset-bottom, 0px));\n  }\n\n  .genius-text {\n    margin: 0 -20px;\n    padding: 4px 20px 8px;\n  }\n\n  .genius-book { font-size: 1.25rem; }\n\n  .genius-p.is-cited { margin-left: -10px; padding-left: 8px; }\n\n  .genius-actions { margin-top: 12px; gap: 8px; }\n}\n\n/* Answers that cite the book: the number is a button that opens the reader.\n   It looks and hits like the other numbers (ChatView.css). */\n.cv-markdown .cv-cite .cv-cite-book {\n  appearance: none;\n  font: inherit;\n  padding: 0.25em 0.2em;\n  margin: 0 -0.2em;\n  border: 0;\n  border-radius: 4px;\n  background: none;\n  color: var(--brand-fg);\n  line-height: 0;\n  text-decoration-line: underline;\n  text-decoration-thickness: 1px;\n  text-underline-offset: 2px;\n  cursor: pointer;\n}\n\n.cv-markdown .cv-cite .cv-cite-book:hover { background: var(--brand-surface-2); }\n\n@media (hover: none) {\n  .cv-markdown .cv-cite .cv-cite-book { position: relative; }\n  .cv-markdown .cv-cite .cv-cite-book::after { content: ''; position: absolute; inset: -12px -9px; }\n  .cv-markdown .cv-cite-more .cv-cite-book::after { left: 0; }\n  .cv-markdown .cv-cite:has(+ .cv-cite-more) .cv-cite-book::after { right: 0; }\n}\n\n@media (hover: hover) {\n  .cv-markdown .cv-cite .cv-cite-book {\n    display: inline-block;\n    min-width: 1.2em;\n    padding: 0.5em 0.3em;\n    margin: -0.5em -0.3em;\n    line-height: 1;\n    text-align: center;\n  }\n}\n\n/* A chapter's source row: a button, laid out like the linked rows. */\nbutton.cv-src {\n  appearance: none;\n  width: 100%;\n  margin: 0;\n  border: 0;\n  border-bottom: 1px solid var(--brand-line);\n  background: none;\n  font: inherit;\n  text-align: left;\n  cursor: pointer;\n}\n\nbutton.cv-src:hover .cv-src-title { text-decoration: underline; text-underline-offset: 0.2em; }\nbutton.cv-src:hover .cv-src-go { background: var(--brand-surface-2); }\n\n/* Under an answer: one quiet line for the book, one for The Net's channel. */\n.cv-promo {\n  margin: 8px 0 0;\n  max-width: var(--measure);\n  font-size: 0.8125rem;\n  line-height: 1.4;\n  color: var(--brand-muted);\n}\n\n.cv-promo a {\n  display: inline-flex;\n  align-items: center;\n  min-height: 44px;\n  color: var(--brand-fg);\n  text-decoration-line: underline;\n  text-underline-offset: 0.2em;\n}\n\n.cv-promo + .cv-promo { margin-top: -8px; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
